export default "__VITE_ASSET__CC8HxvP5__"